export default [
  {
    path: "/roles/add",
    name: "roles-add",
    component: () => import("@/views/roles/role-add/RoleAdd.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Cargos", url: "/roles" },
        { title: "Add", active: true }
      ],
      pageTitle: "Role Add",
      rule: "admin"
    }
  },
  {
    path: "/roles/edit/:roleHash",
    name: "roles-edit",
    component: () => import("@/views/roles/role-edit/RoleEdit.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Cargos", url: "/roles" },
        { title: "Edit", active: true }
      ],
      pageTitle: "Role Edit",
      rule: "admin"
    }
  },
  {
    path: "/roles",
    name: "roles",
    component: () => import("@/views/roles/role-list/RoleList_new.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Cargos" },
        { title: "Lista", active: true }
      ],
      pageTitle: "Cargos",
      rule: "admin"
    }
  }
];

